'use client';
import { useEffect } from 'react';
import { trackEvent } from '@/lib/analytics';

export default function WebVitals() {
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { onCLS, onLCP, onINP, onTTFB } = await import('web-vitals');
        const report = (metric: { name: string; value: number; id: string }) => {
          if (!mounted) return;
          // Send values in milliseconds, rounded to nearest integer
          trackEvent('web_vital', metric.name, metric.id, Math.round(metric.value));
        };
        onCLS(report);
        onLCP(report);
        onINP?.(report as any);
        onTTFB(report);
      } catch {
        // Ignore if web-vitals not available
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);
  return null;
}
